import { checkStatusFunc, parseJSONFunc } from '.';
import { BaseURL } from '../constants';
import { firestore } from '../fire';

export const fetchNewGeneralNews = async (setAppState) => {
  try {
    await fetch(`${BaseURL}/api/generalNews`)
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText); // throws an error if response status is not ok
        }
        checkStatusFunc(res, setAppState);
      })
      .then((res) => parseJSONFunc(res))
      .then((response) => {
        if (response && response.data) {
          var data = {
            NEWS: JSON.stringify(response.data),
            DATE: new Date(),
          };
          firestore.collection('NEWS').doc('GENERAL').set(data);
          setAppState({
            generalArticles: response.data,
          });
        }
      });
  } catch (error) {
    throw new Error(`Failed to fetch`, error);
  }
};
export const fetchGeneralNews = async (setAppState) => {
  var today = new Date();
  await firestore
    .collection('NEWS')
    .doc('GENERAL')
    .get()
    .then((doc) => {
      if (doc.exists) {
        var data = doc.data();
        var difference = today.getTime() - new Date(data['DATE']).getTime();

        difference = difference / 1000 / 3600;
        if (difference < 3) {
          setAppState({
            generalArticles: JSON.parse(data['NEWS']),
          });
        } else {
          fetchNewGeneralNews(setAppState);
        }
      } else {
        fetchNewGeneralNews(setAppState);
      }
    });
};



// WEBPACK FOOTER //
// ./src/Shared/news.js